import { EXCEL_SHEET_FILE_TYPE } from 'src/constants/modal.constants'

import {
  GET_ADMIN_UPLOAD_TEMPLATE,
  GET_ADMIN_UPLOAD_TEMPLATE_LAST_MODIFIED_DATE_TIME,
} from '../../lib/api-routes'
import { instance } from '../../lib/axiosInstance'

export const downloadAdminUploadTemplate = async () => {
  const response = await instance.get<Blob>(GET_ADMIN_UPLOAD_TEMPLATE, {
    responseType: 'blob',
  })
  const blob = new Blob([response?.data], { type: EXCEL_SHEET_FILE_TYPE })

  return await blob?.arrayBuffer()
}

export const adminUploadTemplateLastModifiedDateTime = async () => {
  const response = await instance.get<string>(
    GET_ADMIN_UPLOAD_TEMPLATE_LAST_MODIFIED_DATE_TIME,
    { responseType: 'text' }
  )
  return response?.data
}
